import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAttach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.75 5.844a3.844 3.844 0 0 1 7.688 0v6.468a2.437 2.437 0 1 1-4.876 0V8.376a.75.75 0 0 1 1.5 0v3.938a.937.937 0 1 0 1.876 0v-6.47a2.344 2.344 0 1 0-4.688 0v7.032a3.75 3.75 0 1 0 7.5 0V5a.75.75 0 0 1 1.5 0v7.875a5.25 5.25 0 1 1-10.5 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAttach;
